import axios from 'axios';
import { API_BASE, API_ORIGIN } from './config';


export const fetchHotelSection = async (section, propertyId) => {
  try {
    console.log('[DEBUG] fetchHotelSection URL:', `${API_BASE}/${section}`, 'propertyId:', propertyId);
    console.log('[🌐 Fetch URL]', `${API_BASE}/${section}`, { propertyId });
    const res = await axios.get(`${API_BASE}/${section}`, {
      params: { propertyId }
    });
    return res.data;
  } catch (error) {
    console.error(`[❌ fetchHotelSection] Failed for ${section}:`, error);
    throw error;
  }
};

export const createHotelSection = async (section, data) => {
  try {
    console.log('[DEBUG] createHotelSection URL:', `${API_BASE}/${section}`, 'payload:', data);
    const res = await axios.post(`${API_BASE}/${section}`, data);
    return res.data;
  } catch (error) {
    console.error(`[❌ createHotelSection] Failed for ${section}:`, error);
    throw error;
  }
};

export const updateHotelSection = async (section, id, data) => {
  try {
    console.log('[DEBUG] updateHotelSection URL:', `${API_BASE}/${section}/${id}`, 'payload:', data);
    const res = await axios.put(`${API_BASE}/${section}/${id}`, data);
    return res.data;
  } catch (error) {
    console.error(`[❌ updateHotelSection] Failed for ${section}:`, error);
    throw error;
  }
};

export const deleteHotelSection = async (section, id, propertyId) => {
  try {
    console.log('[DEBUG] deleteHotelSection URL:', `${API_BASE}/${section}/${id}`, 'propertyId:', propertyId);
    const res = await axios.delete(`${API_BASE}/${section}/${id}`, {
      params: { propertyId }
    });
    return res.data;
  } catch (error) {
    console.error(`[❌ deleteHotelSection] Failed for ${section}:`, error);
    throw error;
  }
};

export const uploadImage = async (file, onProgress) => {
  const formData = new FormData();
  formData.append('image', file);

  console.log('[DEBUG] uploadImage URL:', `${API_ORIGIN}/api/upload`, 'file:', file?.name);

  const res = await axios.post(`${API_ORIGIN}/api/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: (event) => {
      const percent = Math.round((event.loaded / event.total) * 100);
      if (onProgress) onProgress(percent);
    }
  });

  console.log('[🧪 Upload Response]', res.data);
  return res.data.imageUrl || res.data.url || res.data.secure_url;
};

export const deleteImage = async (publicId) => {
  try {
    console.log('[DEBUG] deleteImage URL:', `${API_ORIGIN}/api/image`, 'publicId:', publicId);
    console.log('[🌐 Delete Image]', publicId);
    const res = await axios.delete(`${API_ORIGIN}/api/image`, {
      params: { public_id: publicId }
    });
    console.log('[✅ Cloudinary delete response]', res.data);
    return res.data;
  } catch (error) {
    console.error('[❌ deleteImage] Failed:', error);
    throw error;
  }
};
export const undoServiceDelete = async (id, propertyId) => {
  console.log('[DEBUG] undoServiceDelete URL:', `${API_BASE}/services/${id}/restore`, 'propertyId:', propertyId);
  const res = await axios.post(
    `${API_BASE}/services/${id}/restore`,
    { propertyId },
    { headers: { 'Content-Type': 'application/json' } }
  );
  return res.data;
};

export const undoEventDelete = async (id, propertyId) => {
  console.log('[DEBUG] undoEventDelete URL:', `${API_BASE}/events/${id}/restore`, 'propertyId:', propertyId);
  const res = await axios.post(
    `${API_BASE}/events/${id}/restore`,
    { propertyId },
    { headers: { 'Content-Type': 'application/json' } }
  );
  return res.data;
};

export const undoRestaurantDelete = async (id, propertyId) => {
  console.log('[DEBUG] undoRestaurantDelete URL:', `${API_BASE}/restaurants/${id}/restore`, 'propertyId:', propertyId);
  const res = await axios.post(
    `${API_BASE}/restaurants/${id}/restore`,
    { propertyId },
    { headers: { 'Content-Type': 'application/json' } }
  );
  return res.data;
};

export const fetchSingleRestaurant = async (id, propertyId) => {
  try {
    console.log('[DEBUG] fetchSingleRestaurant URL:', `${API_BASE}/restaurants/${id}`, 'propertyId:', propertyId);
    const res = await axios.get(`${API_BASE}/restaurants/${id}`, {
      params: { propertyId }
    });
    return res.data;
  } catch (error) {
    console.error(`[❌ fetchSingleRestaurant] Failed for id ${id}:`, error);
    throw error;
  }
};

export const fetchServiceCategories = async (q, propertyId) => {
  try {
    console.log('[DEBUG] fetchServiceCategories URL:', `${API_BASE}/services/categories`, { q, propertyId });
    const res = await axios.get(`${API_BASE}/services/categories`, {
      params: { q, propertyId }
    });
    return res.data;
  } catch (error) {
    console.error('[❌ fetchServiceCategories] Failed:', error);
    throw error;
  }
};

export const reorderServices = async (propertyId, services) => {
  try {
    const payload = {
      propertyId,
      services: (services || []).map((svc, idx) => ({
        _id: svc._id || svc.id,
        priority: typeof svc.priority === 'number' ? svc.priority : idx,
      })),
    };
    console.log('[DEBUG] reorderServices payload:', payload);
    const res = await axios.post(`${API_BASE}/services/reorder`, payload);
    return res.data;
  } catch (error) {
    console.error('[❌ reorderServices] Failed:', error);
    throw error;
  }
};

// -----------------------------
// Service Settings
// -----------------------------
export const fetchServiceSettings = async (propertyId) => {
  try {
    console.log('[DEBUG] fetchServiceSettings URL:', `${API_BASE}/service-settings/${propertyId}`);
    const res = await axios.get(`${API_BASE}/service-settings/${propertyId}`);
    return res.data;
  } catch (error) {
    console.error('[❌ fetchServiceSettings] Failed:', error);
    throw error;
  }
};

export const updateServiceSettings = async (propertyId, data) => {
  try {
    console.log('[DEBUG] updateServiceSettings URL:', `${API_BASE}/service-settings/${propertyId}`, 'payload:', data);
    const res = await axios.put(`${API_BASE}/service-settings/${propertyId}`, data);
    return res.data;
  } catch (error) {
    console.error('[❌ updateServiceSettings] Failed:', error);
    throw error;
  }
};
